// extracted by mini-css-extract-plugin
module.exports = {"Contacts":"Contacts_Contacts__2qQgq","title":"Contacts_title__hzWl1","subtitle":"Contacts_subtitle__DHQT8","text":"Contacts_text__2-bPK","row":"Contacts_row__NQAhF"};